import styled from "styled-components";
import Loader from "react-loader-spinner";
import React from "react";
import { colors } from "../../../styles/colors";

export const MapContainer = styled.div`
  position: relative;
  height: 100%;
`;

export const MapDiv = styled.div`
  width: 100%;
  min-height: 50vh;
`;

const MapSpinnerLoader = styled(Loader)`
  z-index: 401;
  display: flex;
  background: gray;
  justify-content: center;
  align-items: center;
  opacity: 0.87;
  position: absolute;
  width: 100%;
  height: 100%;
`;

const MapSpinnerTitle = styled.h1`
  position: absolute;
  width: 100%;
  top: 350px;
  z-index: 401;
  color: ${colors.orange};
  font-size: 16pt;
  margin: auto;
  text-align: center;

  @media only screen and (max-width: 478px) { 
    top: 0px;
  }
`;

export const MapSpinner = () => {
  return (
    <>
      <MapSpinnerLoader color={colors.orange} type="TailSpin" />
      <MapSpinnerTitle>Please wait. This could take a while...</MapSpinnerTitle>
    </>
  );
};
